/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取字典码表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<dictionary.BussinessParentDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/business/partner`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
